/** Tipos de Frete  */
export interface TipoFrete {
    id: number;
    nome: string;
    descricao?: string;
}

export const tipoFreteRemetente: TipoFrete = {
    id: 1,
    nome: 'CIF - Remetente',
    descricao: 'Contratação do Frete por conta do Remetente (CIF)'
};
export const tipoFreteDestinatario: TipoFrete = {
    id: 2,
    nome: 'FOB - Destinatário',
    descricao: 'Contratação do Frete por conta do Destinatário (FOB)'
};
export const tipoFreteSemFrete: TipoFrete = {
    id: 3,
    nome: 'Sem Frete',
    descricao: 'Sem Ocorrência de Transporte'
};
export const tipoFreteRedespacho: TipoFrete = {
    id: 4,
    nome: 'Redespacho'
};
export const tipoFreteTerceiros: TipoFrete = {
    id: 5,
    nome: 'Terceiros',
    descricao: 'Contratação do Frete por conta de Terceiros'
};
export const tipoFreteExportacao: TipoFrete = {
    id: 6,
    nome: 'Exportação'
};
export const tipoFreteProprioRemetente: TipoFrete = {
    id: 7,
    nome: 'Próprio por conta do remetente',
    descricao: 'Transporte Próprio por conta do Remetente'
};
export const tipoFreteProprioDestinatario: TipoFrete = {
    id: 8,
    nome: 'Próprio por conta do destinatário',
    descricao: 'Transporte Próprio por conta do Destinatário'
};
export const tipoFreteOutro: TipoFrete = {
    id: 99,
    nome: 'Outro'
};

export const tiposFretes: TipoFrete[] = [
    tipoFreteRemetente,
    tipoFreteDestinatario,
    tipoFreteSemFrete,
    // tipoFreteRedespacho, // Ocultando provisoariamente
    tipoFreteTerceiros,
    tipoFreteExportacao,
    tipoFreteProprioRemetente,
    tipoFreteProprioDestinatario,
    tipoFreteOutro
];

/** Verifica se o tipo de frete é CIF - Remetente */
export function isTipoFreteRemetente(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteRemetente.id;
}

/** Verifica se o tipo de frete é FOB - Destinatário */
export function isTipoFreteDestinatario(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteDestinatario.id;
}

/** Verifica se o tipo de frete é Sem Frete */
export function isTipoFreteSemFrete(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteSemFrete.id;
}

/** Verifica se o tipo de frete é Redespacho */
export function isTipoFreteRedespacho(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteRedespacho.id;
}

/** Verifica se o tipo de frete é Terceiros */
export function isTipoFreteTerceiros(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteTerceiros.id;
}

/** Verifica se o tipo de frete é Exportacao */
export function isTipoFreteExportacao(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteExportacao.id;
}

/** Verifica se o tipo de frete é Próprio Remetente */
export function isTipoFreteProprioRemetente(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteProprioRemetente.id;
}

/** Verifica se o tipo de frete é Próprio Destinatário */
export function isTipoFreteProprioDestinatario(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteProprioDestinatario.id;
}


/** Verifica se o tipo de frete é Outro */
export function isTipoFreteOutro(tipoFrete: number): boolean {
    return tipoFrete === tipoFreteOutro.id;
}
